export default {
    meeting: state => state.meeting,
    feedbackModal: state => state.feedbackModal,
    status: state => state.status,
    twilioToken: state => state.twilioToken,
    roomHash: state => state.meeting.room_hash,
    otherUser: state => state.otherUser,
    canReview: state => state.canReview,
    tipsThankyou: state => state.tipsThankyou,
}
